import { shuffle } from 'lodash-es';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_philosophies as ProviderPhilosophies } from '@/__generated__/getSearchResults';

const PHILOSOPHIES: Record<string, string> = {
  outdoorNature: 'Outdoor/nature',
  developmental: 'Developmental (play-based)',
  montessori: 'Montessori',
  faithBased: 'Faith based',
  academic: 'Academic',
  reggioeEmilia: 'Reggio emilia',
  international: 'International',
  cooperative: 'Cooperative',
  waldorf: 'Day Care',
  specialNeeds: 'Special needs',
};

const shufflePhilosophies = (philosophy: ProviderPhilosophies | null): string[] => {
  if (!philosophy) return [];

  const philosophies = Object.entries(philosophy)
    .filter(([item, value]) => value && PHILOSOPHIES[item])
    .map(([item]) => PHILOSOPHIES[item]);

  return shuffle(philosophies.slice(0, 6));
};

export default shufflePhilosophies;
